import React from 'react';
import { Col, Placeholder, Row } from 'react-bootstrap';
import CardLayout from '../../../../../shared/components/card/CardLayout';

const SectionTitle = ({ className = 'mb-2' }: { className?: string }) => (
    <Placeholder className={`skeleton skeleton-section-title d-block ${className}`} />
);

export function ProfileInfoHeaderSkeleton() {
    return (
        <div
            className="d-flex align-items-center justify-content-center pb-2 w-100 placeholder-glow"
            aria-hidden="true"
        >
            <div className="pe-2">
                <Placeholder className="skeleton skeleton-user-avatar-lg" />
            </div>
            <div>
                <Placeholder className="skeleton skeleton-table-name d-block mb-2" />
                <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-wide d-block mb-2" />
                <Placeholder className="skeleton skeleton-stat-label d-block" />
            </div>
        </div>
    );
}

function SocialPlatformCardSkeleton() {
    return (
        <CardLayout classCard="h-100">
            <div className="d-flex align-items-center">
                <Placeholder className="skeleton skeleton-social-icon" />
                <div className="d-flex flex-column ml-1">
                    <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-wide d-block" />
                    <Placeholder className="skeleton skeleton-stat-label d-block mt-1" />
                </div>
            </div>

            <div className="d-flex justify-content-center gap-1 mt-2">
                {Array.from({ length: 3 }).map((_, i) => (
                    <div
                        key={i}
                        //border
                        className="default-radius p-2 flex-grow-1 d-flex flex-column align-items-center"
                    >
                        <Placeholder className="skeleton skeleton-table-cell" />
                        <Placeholder className="skeleton skeleton-stat-label mt-1" />
                    </div>
                ))}
            </div>

            <Placeholder className="skeleton skeleton-stat-label d-block mt-3 mb-2" />
            <div className="d-flex flex-wrap justify-content-between">
                {Array.from({ length: 3 }).map((_, i) => (
                    <div key={i} className="d-flex align-items-center">
                        <Placeholder className="skeleton skeleton-flag-rect" style={{ width: 40, height: 30 }} />
                        <div className="mx-1">
                            <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-sm d-block" />
                            <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-sm d-block mt-1" />
                        </div>
                    </div>
                ))}
            </div>
        </CardLayout>
    );
}

export function ProfileTabSkeleton() {
    return (
        <Row className="placeholder-glow" aria-hidden="true">
            <Col xs={12} className="mb-3">
                <SectionTitle />
                {[12, 11, 8].map((width, i) => (
                    <Placeholder key={i} xs={width} className="skeleton skeleton-description-line d-block mb-2" />
                ))}
            </Col>

            <Col xs={12} className="mb-2">
                <SectionTitle />
                <div className="d-flex flex-wrap align-items-center">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="my-2 mr-2">
                            <div className="card py-2 px-4 campaign-multiselect d-flex flex-row align-items-center">
                                <Placeholder className="skeleton skeleton-chip-icon" />
                                <Placeholder className="skeleton skeleton-table-cell ml-2" />
                            </div>
                        </div>
                    ))}
                </div>
            </Col>

            <Col xs={12} className="mb-2">
                <SectionTitle />
                <Placeholder xs={8} className="skeleton skeleton-description-line d-block" />
            </Col>
            {Array.from({ length: 3 }).map((_, i) => (
                <Col key={i} xl={4} lg={6} className="my-2">
                    <SocialPlatformCardSkeleton />
                </Col>
            ))}

            <Col xs={12} className="mt-3 mb-3">
                <SectionTitle />
                <Placeholder xs={8} className="skeleton skeleton-description-line d-block" />
            </Col>
            {Array.from({ length: 6 }).map((_, i) => (
                <Col key={i} md={2} className="my-2">
                    <Placeholder className="skeleton skeleton-highlighted-post" />
                </Col>
            ))}
        </Row>
    );
}
